import { useServiceProps, snackbarService, } from "ftl-dashboards-core";
import React from "react";
import FTLSnackbar from "../components/other/FTLSnackbar";
export default ({ style, service = snackbarService, }) => {
    const [props] = useServiceProps(service);
    return (React.createElement(FTLSnackbar, Object.assign({}, props, { style: style, onClose: () => {
            (props === null || props === void 0 ? void 0 : props.onClose) && props.onClose();
            service.close();
        } })));
};
//# sourceMappingURL=SnackbarContainer.js.map